import { render, staticRenderFns } from "./CriteriaList.vue?vue&type=template&id=f49d87d8"
import script from "./CriteriaList.vue?vue&type=script&lang=js"
export * from "./CriteriaList.vue?vue&type=script&lang=js"
import style0 from "./CriteriaList.vue?vue&type=style&index=0&id=f49d87d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports